import _IconButton from "@material-ui/core/esm/IconButton";
import React from 'react';
import classnames from 'classnames';
import ConfigurableLink from 'swag-client-common/components/utils/configurable-link';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import BadgeNumber from '../badge-number';
import classes from './cart-link.scss';
import { getIcon } from './get-cart-icon';
export const CartLink = ({
  className = undefined,
  isHardLink,
  activeClassName = undefined,
  routeNavigationConfirmation,
  itemsNumber = 0,
  isLoading,
  isLimitedEdition,
  showText
}) => {
  return /*#__PURE__*/React.createElement(ConfigurableLink, {
    link: APP_ROUTES.CART,
    className: classnames(className, classes.row),
    activeClassName: activeClassName,
    isHardLink: isHardLink,
    routeNavigationConfirmation: routeNavigationConfirmation
  }, /*#__PURE__*/React.createElement(_IconButton, {
    disableRipple: true,
    className: classes.cartButton,
    size: "small",
    "aria-label": "cart"
  }, /*#__PURE__*/React.createElement(BadgeNumber, {
    badgeClassName: classnames(classes.badge, {
      [classes.orangeBadge]: isLimitedEdition
    }),
    showText: showText,
    spinnerClassName: classes.spinner,
    isLoading: isLoading,
    isLoggedIn: true,
    itemsNumber: itemsNumber,
    iconComponent: /*#__PURE__*/React.createElement("img", {
      src: getIcon(),
      className: classes.icon
    })
  })));
};